import { mapSelectors } from '@citypantry/util';
import { getHeaderState } from '../app.state';
import { HeaderState } from './header.state';

const isNavBarOpen = (state: HeaderState) => state.isNavBarOpen;

export const HeaderSelectors = mapSelectors(getHeaderState, {
  isNavBarOpen,
});
